<div *ngIf="message" class="no-labels-placelhoder empty-list-cta empty-list-cta--small">
    <h1>{{ this.message.title }}</h1>
    <p>
        {{ this.message.body }}
    </p>
</div>
